import React from 'react';
import intl from 'react-intl-universal';
import AuthActions from '../actions/AuthActions';
import { withRouter, Redirect } from 'react-router-dom';
import AuthStore from '../stores/AuthStore';

class LoginFormComponent extends React.Component {

  constructor() {
    super();
    this.state = {
      login: '',
      password: '',
      pack_password: '',
      url: '',
      error: false,
      authenticated: AuthStore.isAuthenticated()
    }
    this.onChange = this.onChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  onChange() {
    this.setState({
      authenticated: AuthStore.isAuthenticated(),
      error: AuthStore._invalid
    });
  }

  componentWillMount() {
    AuthStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    AuthStore.removeChangeListener(this.onChange);
  }

  handleChange(event) {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    if(window.confMode === true){
      if(this.state.url.indexOf(':') > 7){
        let arr = this.state.url.split(':')
        window.ODOO.url = arr[0]+':'+arr[1]
        window.ODOO.port = arr[2]
      } else {
        window.ODOO.url = this.state.url
        window.ODOO.port = ''
      }
      if(window.ODOO.url.endsWith('/')){
        window.ODOO.url = window.ODOO.url.slice(0, -1)
      }
      localStorage.setItem('odoo_conf_url', window.ODOO.url)
      localStorage.setItem('odoo_conf_port', window.ODOO.port)
    }
    AuthActions.logUserIn(this.state.login, this.state.password, this.state.pack_password);
  }

  render() {
    return (
      <div className="login_form">
        { !this.state.authenticated ? (
          <form onSubmit={this.handleSubmit}>
            <h2>{intl.get('Zaloguj się, aby rozpocząć')}</h2>
            {window.confMode === true &&
              <input
                placeholder="url"
                name="url"
                type="text"
                value={this.state.url}
                onChange={this.handleChange} />
            }
            <input
              placeholder={intl.get('login')}
              name="login"
              type="text"
              value={this.state.login}
              onChange={this.handleChange} />
            <input
              placeholder={intl.get('hasło')}
              name="password"
              type="password"
              value={this.state.password}
              onChange={this.handleChange} />
            <input
              placeholder={intl.get('hasło pakowalni')}
              name="pack_password"
              type="password"
              value={this.state.pack_password}
              onChange={this.handleChange} />
            <input type="submit" value="OK" />
            { this.state.error &&
              <div className="login-failed">
                Nieprawidłowy login lub jedno z haseł!
              </div>
            }
          </form>
        ) : (
          <Redirect to='/' />
        )}
      </div>
    );
  }
}

export default withRouter(LoginFormComponent);



// WEBPACK FOOTER //
// ./src/components/LoginForm.js